module.exports = __webpack_public_path__ + "static/media/arrowRight.e93867db.svg";